<div class="vehicle-details-e-toll-tab">

    <div *ngIf="vehicle.RE == true" class="e-toll">
      <div class="column-top">
        <div class="e-toll-status-container mx-3 p-1 rounded-md">

          <div class="e-toll-status" [ngClass]="{
              'tk-i-eToll-status-disabled' : (vehicle.ES === 0) || (vehicle.ES === 1),
              'tk-i-eToll-status-enabled' : (vehicle.ES === 2),
              'tk-i-eToll-status-error' : (vehicle.ES === 3),
              'tk-i-eToll-status-deleyed' : (vehicle.ES === 4)
              }">
          </div>
  
          <div class="status-label" [ngSwitch]='vehicle.ES'>
            <div *ngSwitchCase='0'>
              <b class="mr-1">{{'vehicle-details-etoll-tab.status-off-part1' | translate}}</b>
              {{'vehicle-details-etoll-tab.status-off-part2' | translate}}
            </div>
            <div *ngSwitchCase='1'>
              <b class="mr-1">{{'vehicle-details-etoll-tab.status-off-part1' | translate}}</b>
              {{'vehicle-details-etoll-tab.status-off-part2' | translate}}
            </div>
            <div *ngSwitchCase='2'>
              <b class="mr-1">{{'vehicle-details-etoll-tab.status-sending-part1' | translate}}</b>
              {{'vehicle-details-etoll-tab.status-sending-part2' | translate}}
            </div>
            <div *ngSwitchCase='3'>
              <b class="mr-1">{{'vehicle-details-etoll-tab.status-not-sending-part1' | translate}}</b>
              {{'vehicle-details-etoll-tab.status-not-sending-part2' | translate}}
            </div>
            <div *ngSwitchCase='4'>
              <b class="mr-1">{{'vehicle-details-etoll-tab.status-sending-delay-part1' | translate}}</b>
              {{'vehicle-details-etoll-tab.status-sending-delay-part2' | translate}}
            </div>
          </div>
  
          <p-inputSwitch
            *ngIf="readyToShow"
            [(ngModel)]="sendToEToll"
            (ngModelChange)="ToggleChanged()"
            class="eTollToggle"
          ></p-inputSwitch>
         </div>
  
        <div *ngIf="isETollPanelVisible" class="mx-3 tk-gray-border py-3 px-4 text-xs rounded-md flex">
          <div>
            <div>{{'vehicle-details-etoll-tab.last-etoll-balance-date' | translate}}</div>
            <div class="font-semibold">{{etollBalance | date: 'short'}}</div>
          </div>
          <div class="flex-grow self-center">
            <div class="ml-auto tk-i-etoll-logo"></div>
          </div>
        </div>
  
        <div *ngIf="vehicle.ES === 3" class="eTollErrorWarning">
          <b class="mr-1">{{'vehicle-details-etoll-tab.alert-not-sending-part1' | translate}}</b>
          {{'vehicle-details-etoll-tab.alert-not-sending-part2' | translate}}<br>
            <button class="eTollErrorSupport" (click)="gotToSupport()">
              {{'vehicle-details-etoll-tab.alert-what-todo' | translate}}
            </button>
        </div>
      </div>

      <div class="mx-3">
        <app-vehicle-business-number-pin [vehicle]="vehicle" [title]="'vehicle-details-etoll-tab.data-required-for-etoll' | translate"></app-vehicle-business-number-pin>
      </div>
    </div>

    <!-- urządzenie nie zarejestrowane w e-Toll-->
    <div *ngIf="vehicle.RE == false" class="empty-state">
        <div class="vehicle-no-items-at-all">
            <div class="empty-state-image"></div>
            <div class="empty-state-text">{{'vehicle-details-etoll-tab.not-registered-header' | translate}}</div>
            <div class="empty-state-desc">
              {{'vehicle-details-etoll-tab.not-registered-info-part1' | translate}}<br />
              {{'vehicle-details-etoll-tab.not-registered-info-part2' | translate}}<br />
              {{'vehicle-details-etoll-tab.not-registered-info-part3' | translate}}
            </div>
            <div class="empty-state-address">
                <div>{{'contact.phone-prefix' | translate}} {{'contact.phone' | translate}}</div>
                <div><a href="mailto:{{'contact.email' | translate}}">{{'contact.email' | translate}}</a></div>
            </div>
        </div>
    </div>

</div>
